import React, { useState, useEffect } from "react";
import axios from "axios";
import emailjs from "@emailjs/browser";
import CountrySelector from "./CountrySelector";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const PopUpModal = ({ position, onClose, allCountries, initialCountries }) => {
  const [sending, setSending] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [showAllCountries, setShowAllCountries] = useState(false);
  const [selectedCountry, setSelectedCountry] = useState(
    allCountries.find((c) => c.code === "PK") || allCountries[0]
  );

  const [formData, setFormData] = useState({
    firstName: "",
    email: "",
    phone: "",
    cv: null,
    notes: "",
    termsAccepted: false,
  });

  useEffect(() => {
    if (!dropdownOpen) setShowAllCountries(false);
  }, [dropdownOpen]);

  const handleInputChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleFileChange = (e) => {
    const file = e.target.files[0];
    if (file) setFormData((prev) => ({ ...prev, cv: file }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.cv) {
      toast.error("Please upload your CV");
      return;
    }

    setSending(true);

    try {
      const uploadData = new FormData();
      uploadData.append("cv", formData.cv);

      const uploadRes = await axios.post(
        "http://localhost:5000/upload-cv",
        uploadData
      );

      const cvUrl = uploadRes.data.cvUrl;

      const templateParams = {
        firstName: formData.firstName,
        email: formData.email,
        phone: `${selectedCountry.dial} ${formData.phone}`,
        notes: formData.notes,
        cv_url: cvUrl,
        position: position.title,
      };

      const emailResponse = await emailjs.send(
        process.env.REACT_APP_SERVICE_ID,
        process.env.REACT_APP_TEMPLATE_FORM_ID,
        templateParams,
        process.env.REACT_APP_API_KEY
      );

      if (emailResponse.status === 200) {
        toast.success("Application submitted successfully!");

        // reset form
        setFormData({
          firstName: "",
          email: "",
          phone: "",
          cv: null,
          notes: "",
          termsAccepted: false,
        });

        setTimeout(onClose, 800);
      }
    } catch (error) {
      console.error("Submission error:", error);
      toast.error("Something went wrong. Please try again.");
    } finally {
      setSending(false);
    }
  };

  const displayCountries = showAllCountries ? allCountries : initialCountries;

  return (
    <div
      className="modalOverlay"
      onClick={(e) => e.target.classList.contains("modalOverlay") && onClose()}
    >
      <div className="applicationModal">
        <button className="closeBtn" onClick={onClose}>
          ✕
        </button>

        <form className="formFields" onSubmit={handleSubmit}>
          <div className="formGroup">
            <label>Name</label>
            <input
              type="text"
              name="firstName"
              placeholder="Your Name"
              value={formData.firstName}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="formGroup">
            <label>Email</label>
            <input
              type="email"
              name="email"
              placeholder="you@company.com"
              value={formData.email}
              onChange={handleInputChange}
              required
            />
          </div>

          <div className="formGroup">
            <label>Phone number</label>
            <div className="phone_InputGroup">
              <CountrySelector
                selectedCountry={selectedCountry}
                dropdownOpen={dropdownOpen}
                setDropdownOpen={setDropdownOpen}
                displayCountries={displayCountries}
                handleCountrySelect={(country) => {
                  setSelectedCountry(country);
                  setDropdownOpen(false);
                }}
                showAllCountries={showAllCountries}
                setShowAllCountries={setShowAllCountries}
              />
              <input
                type="tel"
                name="phone"
                placeholder="300 1234567"
                value={formData.phone}
                onChange={handleInputChange}
                required
              />
            </div>
          </div>

          <div className="formGroup">
            <label>Add CV</label>
            <div className="fileUploadWrapper">
              <label className="fileUpload" htmlFor={`cv-${position.id}`}>
                <input
                  type="file"
                  id={`cv-${position.id}`}
                  accept=".pdf,.doc,.docx"
                  onChange={handleFileChange}
                  style={{ display: "none" }}
                />
                <span>
                  {formData.cv ? formData.cv.name : "Click here to add CV"}
                </span>
              </label>
              {formData.cv && (
                <button
                  type="button"
                  className="cancelFileBtn"
                  onClick={() => setFormData((prev) => ({ ...prev, cv: null }))}
                >
                  ✕
                </button>
              )}
            </div>
          </div>

          <div className="formGroup">
            <label>Notes</label>
            <textarea
              rows="3"
              name="notes"
              value={formData.notes}
              onChange={handleInputChange}
            ></textarea>
          </div>

          <div className="termsWrapper">
            <label>Terms & Conditions</label>
            <div className="termsInfo">
              <ul className="termsList">
                <li>All information provided must be accurate and truthful.</li>
                <li>
                  Your CV and personal data will be used solely for recruitment
                  purposes.
                </li>
                <li>
                  We reserve the right to verify the information you provide.
                </li>
                <li>
                  By applying, you consent to background checks if required for
                  the position.
                </li>
                <li>
                  Your application will be kept confidential and handled
                  securely.
                </li>
              </ul>
            </div>

            <div className="formCheckbox">
              <input
                type="checkbox"
                id={`terms-${position.id}`}
                name="termsAccepted"
                checked={formData.termsAccepted}
                onChange={handleInputChange}
                required
              />
              <label htmlFor={`terms-${position.id}`}>
                I agree to the Terms & Conditions
              </label>
            </div>
          </div>

          <button
            type="submit"
            className="applyBtn"
            disabled={!formData.termsAccepted || sending}
          >
            {sending ? "Processing..." : "Apply"}
          </button>
        </form>
      </div>
    </div>
  );
};

export default PopUpModal;
